import { useEffect, useRef } from 'react';
import { trackPriceSectionView } from './enhancedAnalytics';

export function usePriceSectionView(ref, payload, enabled = true) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!enabled || firedRef.current) return undefined;
    const node = ref?.current;
    if (!node || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting) || firedRef.current) return;
        firedRef.current = true;
        trackPriceSectionView(payload);
        observer.disconnect();
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, enabled, payload]);
}
